var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"list-delivery-detail"},_vm._l((_vm.mailItemList),function(deliveryItem,index){return _c('DeliveryDetailItem',{key:index,staticClass:"delivery-detail",attrs:{"mailItem":deliveryItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }